import qs from "qs";
import request from "@/utils/requestSC";
import openRequest from "@/utils/request";

// 获取订单提交信息
export async function getConfirmOrderInfo(params) {
  return request.post("/rest/order/confirmOrder", params);
}

export async function shopDeliveryList(params) {
  return request.post("/mob/shopDelivery/shopDeliveryList", params);
}

export async function toFreightAmountNew(params) {
  return request.post("/mob/mj/freight/toFreightAmountNew", params);
}
export async function toFreightAmountNew2(params) {
  return request.post("/mob/mj/freight/toFreightAmountNew", qs.stringify(params));
}

export async function queryShopByAxis(params) {
  return request.post("/order/queryShopByAxis", params);
}

export async function alterDelivery(params) {
  return request.post("/mob/member/delivery/alterDelivery", params);
}

export async function updateAddr(params) {
  return request.post("/mob/member/delivery/updateAddr", params);
}

export async function deleteAddr(params) {
  return request.post("/mob/member/delivery/delete", params);
}

// 新增收货地址
export async function addAddr(params) {
  return request.post("/mob/member/delivery/add", params);
}

export async function queryAddrList(params) {
  return request.post("/mob/order/queryAddrList", params);
}

export async function compareAddr(params) {
  return request.post("/mobRecode/order/compareAddr", qs.stringify(params));
}

export async function promotionDtl(params) {
  return request.post("/mob/promotionDtl/query", params);
}

export async function orderSubmit(params) {
  return request.post("/mobRecode/order/orderSubmit", params);
}

export async function submitOrder(params) {
  return request.post("/rest/order/submitOrder", qs.stringify(params));
}

export async function getEnterpriseList(params) {
  return openRequest.get("nxin.usercenter.enterprise.list/5.0", params);
}

export async function getOrderStatusByOrder(params) {
  return request.get("/api/order/queryOrderStatusByOrderId", { params });
}

export async function updateEnterprise(params) {
  return openRequest({
    url: "nxin.usercenter.enterprise.update/1.0",
    method: "get",
    params
  });
}
